import { render, staticRenderFns } from "./DirectOutgoingRB.vue?vue&type=template&id=3e6c28a4&scoped=true&"
import script from "./DirectOutgoingRB.vue?vue&type=script&lang=js&"
export * from "./DirectOutgoingRB.vue?vue&type=script&lang=js&"
import style0 from "./DirectOutgoingRB.vue?vue&type=style&index=0&id=3e6c28a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6c28a4",
  null
  
)

export default component.exports